import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { EMPTY_FUNCTION } from '../config/constants'
import { isRetryableError } from 'src/utils/helpers'

export const ErrorContext = React.createContext({
  setError: EMPTY_FUNCTION,
  error: null
})

const ErrorProvider = (props) => {
  const [error, setError] = useState(null)

  const errorState = useMemo(
    () => ({
      error,
      setError: (error) => {
        if (error) {
          setError({
            ...error,
            isRetryable:
              !!error.retryCallback &&
              (error.forceRetry || isRetryableError(error.errorCodeLabel))
          })
          return
        }
        setError(error)
      }
    }),
    [error]
  )

  return (
    <ErrorContext.Provider value={errorState}>
      {props.children}
    </ErrorContext.Provider>
  )
}

ErrorProvider.propTypes = {
  children: PropTypes.node
}

export default ErrorProvider
